import React from 'react';
import PropTypes from 'prop-types';
import Indentation from './indentation';
const Target = _ref => {
  let level = _ref.level;
  return /*#__PURE__*/React.createElement("div", {
    style: {
      backgroundColor: 'transparent',
      padding: '5px',
      borderRadius: '3px'
    }
  }, /*#__PURE__*/React.createElement(Indentation, {
    level: level
  }), /*#__PURE__*/React.createElement("i", {
    className: "fas fa-bullseye t-tn-target",
    style: {
      marginLeft: '15px'
    }
  }), " move here");
};
Target.propTypes = {
  level: PropTypes.number.isRequired
};
export default Target;